'use strict';
module.exports = function baseName(url) {
	return url.replace(/\\/g, '/').replace(/.*\//, '').replace(/\.[^.]*$/, '');
};
